import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	addBead(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		delete headers['Content-Type'];
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `knowledgebead`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	updateBead(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		delete headers['Content-Type'];
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `knowledgebead/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	manageResource(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `resource/manage`;
		return this.http.get(api, options);
	}
}
